/* ClarityImpactStrip — public, aggregated proof of measured clarity change.
   Hidden until at least one user has both a before AND after score. */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TrendingUp, Users, ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ClarityImpactStrip = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/clarity-score/stats`)
      .then(({ data }) => setStats(data))
      .catch(() => {});
  }, []);

  if (!stats || !stats.users_measured) return null;

  return (
    <section className="py-12 md:py-14 px-4 md:px-6" style={{ background: '#0F172A' }} data-testid="clarity-impact-strip">
      <div className="max-w-6xl mx-auto">
        <div className="text-xs font-semibold tracking-widest text-teal-400 uppercase mb-4 flex items-center gap-2">
          <TrendingUp size={13} /> Measured impact — not opinions
        </div>
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-12">
          <div>
            <p className="text-sm text-slate-400 mb-1">Career clarity, self-rated by signed-in users</p>
            <div className="flex items-baseline gap-3">
              <span className="text-4xl md:text-5xl font-extrabold text-slate-500">{stats.avg_before}<span className="text-lg text-slate-600">/10</span></span>
              <span className="text-teal-400 font-black text-2xl">→</span>
              <span className="text-4xl md:text-5xl font-extrabold text-emerald-400" data-testid="clarity-impact-after">{stats.avg_after}<span className="text-lg text-emerald-600">/10</span></span>
            </div>
            <p className="text-[11px] text-slate-500 mt-1.5">before using LearnixTa → after exploring their path</p>
          </div>
          <div className="grid grid-cols-2 gap-4 md:gap-8">
            <div>
              <div className="flex items-center gap-1.5 text-slate-400 text-xs font-bold uppercase tracking-wider"><Users size={12} /> Measured on</div>
              <p className="text-2xl font-extrabold text-white mt-1" data-testid="clarity-impact-count">{stats.users_measured} user{stats.users_measured !== 1 ? 's' : ''}</p>
              <p className="text-[11px] text-slate-500">signed-in, asked twice</p>
            </div>
            <div>
              <div className="flex items-center gap-1.5 text-slate-400 text-xs font-bold uppercase tracking-wider"><ShieldCheck size={12} /> Left clearer</div>
              <p className="text-2xl font-extrabold text-white mt-1">{stats.improved_out_of_10} out of 10</p>
              <p className="text-[11px] text-slate-500">rated themselves higher after</p>
            </div>
          </div>
        </div>
        <p className="text-[10px] text-slate-600 mt-5">
          Self-reported by real signed-in users on a 1–10 scale, asked before and after using LearnixTa. Updated live. No handpicking.
        </p>
      </div>
    </section>
  );
};

export default ClarityImpactStrip;
